
// var APIusername = '-11';
// var APIpassword = 'DC6F7CCB2DAD40BB9AF09BBFF07C273A' 
const APItokenCode ="LTExOkRDNkY3Q0NCMkRBRDQwQkI5QUYwOUJCRkYwN0MyNzNB";// `${APIusername}:${APIpassword}`; 
export default APItokenCode; 